import { HomePageStarredEntities } from '@backstage/plugin-home';
import { LinksPage } from '@internal/backstage-plugin-links';
import { Content, Page, InfoCard } from '@backstage/core-components';
import { Header } from '@backstage/ui';
import { Grid } from '@backstage/ui';
import Tour from '../tour/Tour';
import { NewAnnouncementBanner } from '@backstage-community/plugin-announcements';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { ExtensionDefinition } from '@backstage/frontend-plugin-api';

const homePageLayout: ExtensionDefinition = HomePageLayoutBlueprint.make({
  params: {
    loader: async () =>
      function MyHomePageLayout() {
        return (
          <Page themeId="home">
            <Content>
              <Header title="Welcome to the intive Developer Platform!" />
              <Grid.Root columns="1" gap="4">
                <div>
                  <NewAnnouncementBanner />
                </div>
              </Grid.Root>
              <Grid.Root columns="3" gap="4">
                <div>
                  <InfoCard title="Take a tour!">
                    <Tour />
                  </InfoCard>
                </div>
                <div>
                  <HomePageStarredEntities />
                </div>
                <div>
                  <LinksPage title="Links" />
                </div>
              </Grid.Root>
            </Content>
          </Page>
        );
      },
  },
});

export default homePageLayout;
